import * as T from 'io-ts'

export const UserCodec = T.type({
  username: T.string,
  storeNumber: T.Int,
})

export type User = T.TypeOf<typeof UserCodec>

export const LoggedInUserCodec = T.intersection([UserCodec, T.type({ token: T.string })])

export type LoggedInUser = T.TypeOf<typeof LoggedInUserCodec>
